import { Modal, Button, Typography } from "antd";
import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { StyleSheet, Font } from "@react-pdf/renderer";

import { useAppSelector, useAppDispatch } from "store/hook";
import { setPDFVisible } from "Components/Report/reportSlice";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const { Text } = Typography;

Font.register({
  family: "ZCool",
  src: "https://fonts.gstatic.com/s/zcoolkuaile/v7/tssqApdaRQokwFjFJjvM6h2WpozzoXhC2g.ttf",
});

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },

  text: {
    margin: 12,
    fontSize: 54,
    textAlign: "justify",
    fontFamily: "ZCool",
  },
});

const ViewPDF = ({
  PDF,
  setPDF,
}: // data,
// isModalVisible,
// setIsModalVisible,
{
  PDF: File | undefined;
  setPDF: (arg: File | undefined) => void;
  // isModalVisible: boolean;
  // setIsModalVisible: (arg: boolean) => void;
}) => {
  const disp = useAppDispatch();
  const { PDFVisible } = useAppSelector((state) => state.report);
  const [numPages, setNumPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
  }

  function changePage(offset: number) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  const closeModal = (): void => {
    disp(setPDFVisible(false));
    setPDF(undefined);
    setNumPages(1);
    setPageNumber(1);
  };

  return (
    <>
      <Modal
        visible={PDFVisible}
        // onOk={closeModal}
        onCancel={closeModal}
        bodyStyle={{ padding: 0, width: "100%" }}
        // closable={false}
        className="pdf__model"
        maskClosable={false}
        width="580px"
        style={{ top: 20, zIndex: 9999 }}
        footer={[
          <div
            style={{
              background: "white",
              display: "flex",
              padding: "5px 10px 5px 10px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* <Text strong>
              Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
            </Text> */}
            <div>
              <Button type="primary" size="small" disabled={pageNumber <= 1} onClick={previousPage}>
                Previous
              </Button>
              <Button type="primary" size="small" disabled={pageNumber >= numPages} onClick={nextPage}>
                Next
              </Button>
            </div>
          </div>,
        ]}
      >
        <Document
          file={PDF}
          onLoadSuccess={onDocumentLoadSuccess}
          options={{
            cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
            cMapPacked: true,
            // standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts`,
            standardFontDataUrl: "https://cdn.jsdelivr.net/npm/taipei-sans-tc",
          }}
        >
          {/* {Array.from(new Array(numPages), (el, index) => (
            <Page key={`page_${index + 1}`} pageNumber={index + 1} width={950} />
       
          ))} */}
          <Page pageNumber={pageNumber} width={580} />
        </Document>
      </Modal>
    </>
  );
};

export default ViewPDF;
